import styled from "styled-components";
import Colors from "./colors";

export const FormField = styled.div`
  margin-bottom: 24px;

  ${(props) =>
    props.horizontal &&
    `
    display: flex;
    align-items: center;
  `}
`;

export const Label = styled.label`
  display: block;
  color: #000;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding-bottom: 5px;
`;

export const Input = styled.input`
  background: #fff;
  border: 1px solid ${Colors.Mist};
  border-radius: 3px;
  padding: 10px 20px;
  box-sizing: border-box;
  width: 100%;

  color: #000;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  transition: flex .25s ease-in-out;

  ${(props) =>
    props.readOnly &&
    `
    background: #e9ecef;
  `}

  :focus {
    border-color: ${Colors.Orange};
    ${(props) => props.animateExpand && 'flex: 10 !important;'}
  }
`;



// WEBPACK FOOTER //
// ./src/core/admin/components/styled/form-fields.js